import { Image, Modal, ModalProps } from '@mantine/core';
import { FileWithPath, IMAGE_MIME_TYPE, PDF_MIME_TYPE } from '@mantine/dropzone';
import { useMediaQuery } from '@mantine/hooks';
import { useMemo } from 'react';
import { pdfjs } from 'react-pdf';
import { PdfPreview } from '../PdfPreview/PdfPreview';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

function isImage(file: PreviewFile): boolean {
    return file.type ? (IMAGE_MIME_TYPE as string[]).includes(file.type) : false;
}

function isPDF(file: PreviewFile): boolean {
    return file.type ? (PDF_MIME_TYPE as string[]).includes(file.type) : false;
}

function isSupported(file: PreviewFile): boolean {
    const supportedTypes: string[] = [...IMAGE_MIME_TYPE, ...PDF_MIME_TYPE];
    return file.type ? supportedTypes.includes(file.type) : false;
}

type PreviewFile = FileWithPath | RemoteFile;

interface RemoteFile {
    url: string;
    type?: string;
    name?: string;
}

type PreviewModalProps = {
    file?: PreviewFile;
} & ModalProps;

export function PreviewModal({ file, ...props }: PreviewModalProps) {
    const isMobile = useMediaQuery('(max-width: 50em)');
    const url = useMemo(() => {
        return !file ? undefined : 'url' in file ? file.url : URL.createObjectURL(file);
    }, [file]);

    return (
        <Modal {...props} title={file?.name} size="xl" fullScreen={isMobile} centered transitionProps={{ duration: 200, transition: 'fade' }}>
            {file && isSupported(file) ? isImage(file) ? <Image src={url} mah="75vh" /> : isPDF(file) ? <PdfPreview file={url} /> : null : null}
        </Modal>
    );
}
